module.exports = __webpack_public_path__ + "img/safe_logo.58c93759.png";